<h3 class="title configurator-title">{{ 'closet-doors-custom.summary.title' | translate }}</h3>

<ng-casto-loader *ngIf="!configuration.resume"></ng-casto-loader>

<ng-container *ngIf="configuration.resume">
  <div class="summary-container shadow mt-4" *ngFor="let categoryName of getCategories()">
    <h4 class="title summary-title">{{ categoryName }}</h4>

    <div class="summary-infos">
      <p class="info" *ngFor="let product of getProducts(categoryName)">
        {{ product.name }} {{ product.value ? ':' : '' }}
        {{ product.width != null ? product.width + 'mm' : product.value }}
      </p>
    </div>
  </div>

  <div class="summary-container prices-container shadow mt-4">
    <div *ngIf="!configuration.resume.hasPriceError">
      <div class="price-row">
        <h4 class="title summary-title">{{ 'closet-doors-custom.summary.total-without-vat' | translate }} :</h4>
        <p *ngIf="!configuration.resume.totalDiscountHT" class="info">
          {{ configuration.resume.totalHT | number: '1.2-2' : 'fr' }} €
        </p>
        <span *ngIf="configuration.resume.totalDiscountHT" class="info"
          ><p>
            <s
              ><i>{{ configuration.resume.totalHT | number: '1.2-2' : 'fr' }} €</i></s
            >
          </p>
          <p>
            {{ configuration.resume.totalHT - configuration.resume.totalDiscountHT | number: '1.2-2' : 'fr' }} €
          </p></span
        >
      </div>
      <div class="price-row">
        <h4 class="title summary-title">{{ 'closet-doors-custom.summary.vat-total' | translate }} :</h4>
        <p *ngIf="!configuration.resume.totalDiscountTVA" class="info">
          {{ configuration.resume.totalTVA | number: '1.2-2' : 'fr' }} €
        </p>
        <span *ngIf="configuration.resume.totalDiscountTVA" class="info"
          ><p>
            <s
              ><i>{{ configuration.resume.totalTVA | number: '1.2-2' : 'fr' }} €</i></s
            >
          </p>
          <p>
            {{ configuration.resume.totalTVA - configuration.resume.totalDiscountTVA | number: '1.2-2' : 'fr' }} €
          </p></span
        >
      </div>
      <div class="price-row principale">
        <h4 class="title summary-title">{{ 'closet-doors-custom.summary.total-with-vat' | translate }} :</h4>
        <p *ngIf="!configuration.resume.totalDiscountPV" class="info">
          {{ configuration.resume.totalPV | number: '1.2-2' : 'fr' }} €
        </p>
        <span *ngIf="configuration.resume.totalDiscountPV" class="info"
          ><p>
            <s
              ><i>{{ configuration.resume.totalPV | number: '1.2-2' : 'fr' }} €</i></s
            >
          </p>
          <p>
            {{ configuration.resume.totalPV - configuration.resume.totalDiscountPV | number: '1.2-2' : 'fr' }} €
          </p></span
        >
      </div>
      <div class="price-row">
        <h1 class="title summary-title">{{ 'closet-doors-custom.summary.ecotax' | translate }} :</h1>
        <p class="info">{{ configuration.resume.ecotax }} €</p>
      </div>
    </div>
    <div *ngIf="configuration.resume.hasPriceError">
      <p>
        {{
          ('closet-doors-custom.error.price' | translate: { supplierName: configuration.supplier.name }) +
            ' (' +
            configuration.resume.priceErrorCode +
            ')'
        }}
      </p>
    </div>
  </div>
</ng-container>
